import { IObserver, Subject } from './subject.class'
import { cover } from '../../utility/constant/helper.constant'
import { Chata, Dari, Model } from '../../classes/model'
import { TTerraceModel, TTerraceWidth } from '../../utility/type/terraceCover.type'

/**
 * Keeps track of updates regarding the width of the windows
 */
export class WidthObserver implements IObserver {
  private readonly _subject: Subject
  private _windowsTopTotal: number = cover.terraceCover.windowsTopTotal
  private _windowsTopWidth: number = cover.terraceCover.windowsTopWidth()
  private _logsTotal: number = cover.terraceCover.logsTopTotal()
  private _windowsFrontTotal: number = cover.terraceCover.windowsFrontTotal
  private _windowsFrontWidth: number = cover.terraceCover.windowsFrontWidth()
  private _logsFrontTotal: number = cover.terraceCover.logsFrontTotal()

  constructor(subject: Subject) {
    this._subject = subject
    subject.registerObserver(this)
  }

  get windowsTopTotal() {
    return this._windowsTopTotal
  }

  get windowsTopWidth() {
    return this._windowsTopWidth
  }

  get logsTopTotal() {
    return this._logsTotal
  }

  get windowsFrontTotal() {
    return this._windowsFrontTotal
  }

  get windowsFrontWidth() {
    return this._windowsFrontWidth
  }

  get logsFrontTotal() {
    return this._logsFrontTotal
  }

  /**
   * Observer method that is called by the subject class
   * @param model Either DARI or CHATA
   * @param width Width of the terrace
   * @returns Total windows based on model
   */
  public updateWidth(model: TTerraceModel, width: TTerraceWidth) {
    // TODO
    if (model === 'DARI') {
      this._windowsTopTotal = Dari.windowsTop(width)
    }

    // TODO
    if (model === 'CHATA') {
      this._windowsTopTotal = Chata.windowsTop(width)
    }

    this._logsTotal = Model.logsTopTotal(width)
    this._windowsTopWidth = Model.windowsTopWidth(width, this._windowsTopTotal)
    this._windowsFrontTotal = Model.windowsFront(width)
    this._windowsFrontWidth = Model.windowsFrontWidth(
      width,
      this._windowsFrontTotal
    )

    this._logsFrontTotal = Model.logsFrontTotal(width)
  }
}
